

export const checkPermission = (user: any, key: any) => {
  //skip check permission for super admin
  if (user && user.id == 1) {
    return true;
  }
  const permissionsData = user.permissionNames ? user.permissionNames : [];
  return permissionsData.includes(key);
};


export const checkPermissions = (user: any, keyArr: any) => {
  //skip check permission for super admin
  if (user && user.id == 1) {
    return true;
  }
  const permissionsData = user.permissionNames ? user.permissionNames : [];
  var allow = false;
  if (keyArr) {
    keyArr.map((key: any) => {
      if (permissionsData.includes(key)) {
        allow = true;
        return;
      }
    });
  }
  return allow;
}



